import { Box, Center, Title } from "@mantine/core";
import Exstusertable from "../Components/Admin/Exstusertable";











const Exuserdetails = () => {
    return (
        <>
            <Center mt={'xs'}><Title c={'dimmed'}>Exst. User Details</Title></Center>
            <Box mt={'md'}>
                <Exstusertable />
            </Box>

        </>
    )
}
export default Exuserdetails;